import React, {useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import {isTimeNotUp} from "../../../helper";
import ButtonComponent from "../../button/buttonComponent";
import {updateSeasonPlayerStatsInit} from "../../../services/seasonService";
import ConfirmationTxtLbComponent from "../../layout/confirmationTxtLbComponent";
import NbaPlayoffInputItemComponent from "../../input/nbaPlayoff/nbaPlayoffInputItemComponent";
import {nbaPlayoffSeriesInputOptions} from "../../../constants/variables";

function NbaFinalsPredictionsFormComponent(props) {
    const dispatch = useDispatch();
    const [buttonsDisabled, setButtonsDisabled] = useState(false);
    const [confirmationTxt, setConfirmationTxt] = useState(null);

    const [predictionsLb, setPredictionsLb] = useState(null);
    const [statisticsLb, setStatisticsLb] = useState(null);

    const [east_vs_west_prediction, set_east_vs_west_prediction] = useState(null);
    const [scorer_prediction, set_scorer_prediction] = useState(null);

    const [is_east_vs_west_active, set_east_vs_west_active] = useState("");
    const [is_scorer_active, set_scorer_active] = useState("");

    useEffect(() => {
        if (props.playerStats) {

            if (props.playerStats.finals_predictions.east_vs_west) {
                const value = props.playerStats.finals_predictions.east_vs_west;
                set_east_vs_west_prediction({
                    value: value,
                    label: value.split("_")[1] + "-" + value.split("_")[2],
                })
            }

            if (props.playerStats.finals_predictions.scorer) {
                set_scorer_prediction({
                    value: props.playerStats.finals_predictions.scorer,
                    label: props.playerStats.finals_predictions.scorer,
                })
            }
        }
    }, [props.playerStats]);

    useEffect(() => {
        setStartTimeActives();
    }, [props.season.info]);

    useEffect(() => {
        setStartTimeActives();
    }, []);

    const setStartTimeActives = () => {
        if (props.season.info) {
            props.season.info.finals.east_vs_west.start_time && set_east_vs_west_active(isTimeNotUp(props.season.now, props.season.info.finals.east_vs_west.start_time))
            props.season.info.finals.scorer.start_time && set_scorer_active(isTimeNotUp(props.season.now, props.season.info.finals.scorer.start_time))
        }
    }

    const submitPredictions = () => {
        setButtonsDisabled(true)

        const newPlayerStats = structuredClone(props.playerStats);

        newPlayerStats.finals_predictions = {
            east_vs_west: east_vs_west_prediction ? east_vs_west_prediction.value : null,
            scorer: scorer_prediction ? scorer_prediction.value : null,
        };

        updateSeasonPlayerStatsInit(props.season.type, newPlayerStats, dispatch).then(_ => {
            setButtonsDisabled(false);
            setConfirmationTxt("NBA Finalleri tahminlerin kaydedildi.")
        });
    }

    return (
        <form onSubmit={(e) => e.preventDefault()}>

            {
                props.season.info.finals.east_vs_west.start_time && props.seasonStats &&
                <NbaPlayoffInputItemComponent
                    is_active={is_east_vs_west_active}
                    inputValue={east_vs_west_prediction}
                    setInputValue={set_east_vs_west_prediction}
                    inputName={"east_vs_west"}
                    labelText={`${props.season.info.finals.east_vs_west.team_1} vs. ${props.season.info.finals.east_vs_west.team_2}`}
                    stats={props.seasonStats.statistics.finals.east_vs_west}
                    predictions={props.seasonStats.playersPredictions.finals.east_vs_west}
                    info={props.season.info.finals.east_vs_west}
                    inputOptions={nbaPlayoffSeriesInputOptions}
                    setStatisticsLb={setStatisticsLb}
                    statisticsLb={statisticsLb}
                    setPredictionsLb={setPredictionsLb}
                    predictionsLb={predictionsLb}
                    buttonsDisabled={buttonsDisabled}
                />
            }

            {
                props.season.info.finals.scorer.start_time && props.seasonStats &&
                <NbaPlayoffInputItemComponent
                    is_active={is_scorer_active}
                    inputValue={scorer_prediction}
                    setInputValue={set_scorer_prediction}
                    inputName={"scorer"}
                    labelText={`Final Serisinin En Skorer Oyuncusu`}
                    predictions={props.seasonStats.playersPredictions.finals.scorer}
                    info={props.season.info.finals.scorer}
                    inputOptions={props.season.info.finals.scorer.list.sort().map(x => ({value: x, label:x}))}
                    setPredictionsLb={setPredictionsLb}
                    predictionsLb={predictionsLb}
                    buttonsDisabled={buttonsDisabled}
                    stats={props.seasonStats.statistics.finals.scorer}
                    setStatisticsLb={setStatisticsLb}
                    statisticsLb={statisticsLb}
                />
            }

            {
                props.playerStats && (is_east_vs_west_active || is_scorer_active) &&
                <ButtonComponent type="submit" text={"Kaydet"} onClick={submitPredictions}
                                 isDisabled={buttonsDisabled}/>
            }

            {
                confirmationTxt &&
                <ConfirmationTxtLbComponent text={confirmationTxt} setConfirmationTxt={setConfirmationTxt}/>
            }

        </form>
    );
}

const mapStateToProps = (state) => ({
    season: state.seasonReducer.season,
    playerStats: state.seasonReducer.playerStats,
    allPlayersStats: state.seasonReducer.allPlayersStats,
    seasonStats: state.seasonReducer.seasonStats,
})

export default connect(mapStateToProps)(NbaFinalsPredictionsFormComponent);